/* Let each phone slide fit its own content instead of the longest slide's height. */
(() => {
  const bound = new WeakSet();
  const phone = window.matchMedia('(max-width: 767.98px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function attach(scope = document) {
    scope.querySelectorAll('slideshow-component.slideshow-content-mobile--below').forEach((element) => {
      if (bound.has(element)) return;
      const slider = element.sliderInstance?.slider;
      if (!slider) return;
      bound.add(element);
      let frame;
      const measure = () => {
        if (phone.matches && !slider.destroyed) {
          slider.updateAutoHeight(reducedMotion.matches ? 0 : 180);
        }
      };
      const resize = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          if (slider.destroyed || !element.isConnected) return;
          slider.params.autoHeight = phone.matches;
          element.classList.toggle('swiper-autoheight', phone.matches);
          if (!phone.matches) slider.wrapperEl.style.removeProperty('height');
          slider.update();
          measure();
        });
      };
      slider.on('slideChangeTransitionStart', measure);
      window.addEventListener('resize', resize);
      element.querySelectorAll('img').forEach((image) => {
        if (!image.complete) image.addEventListener('load', resize, { once: true });
      });
      document.fonts.ready.then(resize);
      const section = element.closest('.shopify-section');
      const unload = (event) => {
        if (event.target !== section) return;
        cancelAnimationFrame(frame);
        window.removeEventListener('resize', resize);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
      resize();
    });
  }

  customElements.whenDefined('slideshow-component').then(() => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => attach(), { once: true });
    } else {
      attach();
    }
    document.addEventListener('shopify:section:load', (event) => attach(event.target));
  });
})();
